import React, { lazy } from 'react';
import { Layout } from '../components/layout/Layout';
import { SectionHeading } from '../components/ui/SectionHeading';
import { Button } from '../components/ui/Button';
import { MapPin, Phone, Mail, Clock, Send } from 'lucide-react';
export function ContactPage() {
  return <Layout data-id="element-429">
      {/* Header */}
      <div className="bg-[#0A1F44] pt-44 md:pt-48 pb-20 text-center text-white relative overflow-hidden" data-id="element-430">
        <div className="absolute inset-0 opacity-20" data-id="element-431">
          <img src="https://images.unsplash.com/photo-1478147427282-58a87a120781?ixlib=rb-4.0.3&auto=format&fit=crop&w=2000&q=80" alt="Background" className="w-full h-full object-cover" data-id="element-432" />
        </div>
        <div className="absolute inset-0 bg-gradient-to-b from-[#0A1F44] via-[#0A1F44]/70 to-[#0A1F44]" data-id="element-433" />
        <div className="container-custom relative z-10" data-id="element-434">
          <h1 className="text-4xl md:text-6xl font-serif font-bold mb-4" data-id="element-435">
            Contact Us
          </h1>
          <p className="text-xl text-white/80 max-w-2xl mx-auto" data-id="element-436">
            We'd love to hear from you. Reach out with any questions or prayer
            requests.
          </p>
        </div>
      </div>

      <section className="py-20 bg-white" data-id="element-437">
        <div className="container-custom" data-id="element-438">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16" data-id="element-439">
            {/* Contact Info */}
            <div data-id="element-440">
              <SectionHeading title="Get In Touch" subtitle="Reach Out" alignment="left" data-id="element-441" />
              <p className="text-gray-600 mb-10 text-lg" data-id="element-442">
                Whether you have a question about our ministries, need prayer,
                or want to know more about The Household, our team is ready to
                connect with you.
              </p>

              <div className="space-y-8" data-id="element-443">
                <div className="flex items-start gap-6" data-id="element-444">
                  <div className="w-14 h-14 bg-[#F5F7FA] rounded-full flex items-center justify-center text-[#C8102E] shrink-0" data-id="element-445">
                    <MapPin className="w-6 h-6" data-id="element-446" />
                  </div>
                  <div data-id="element-447">
                    <h3 className="text-xl font-bold text-[#0A1F44] mb-2" data-id="element-448">
                      Visit Us
                    </h3>
                    <p className="text-gray-600" data-id="element-449">
                      1221 Caraway Ct, #1090
                      <br data-id="element-450" />
                      Largo, MD 20774
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-6" data-id="element-451">
                  <div className="w-14 h-14 bg-[#F5F7FA] rounded-full flex items-center justify-center text-[#C8102E] shrink-0" data-id="element-452">
                    <Phone className="w-6 h-6" data-id="element-453" />
                  </div>
                  <div data-id="element-454">
                    <h3 className="text-xl font-bold text-[#0A1F44] mb-2" data-id="element-455">
                      Call Us
                    </h3>
                    <p className="text-gray-600" data-id="element-456">
                      <a href="tel:301-996-6907" className="hover:text-[#C8102E] transition-colors" data-id="element-457">
                        (301) 996-6907
                      </a>
                    </p>
                    <p className="text-sm text-gray-500 mt-1" data-id="element-458">
                      Mon-Fri, 9am - 5pm EST
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-6" data-id="element-459">
                  <div className="w-14 h-14 bg-[#F5F7FA] rounded-full flex items-center justify-center text-[#C8102E] shrink-0" data-id="element-460">
                    <Mail className="w-6 h-6" data-id="element-461" />
                  </div>
                  <div data-id="element-462">
                    <h3 className="text-xl font-bold text-[#0A1F44] mb-2" data-id="element-463">
                      Email Us
                    </h3>
                    <p className="text-gray-600" data-id="element-464">
                      <a href="mailto:info@householdchurch.org" className="hover:text-[#C8102E] transition-colors" data-id="element-465">
                        info@householdchurch.org
                      </a>
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-6" data-id="element-466">
                  <div className="w-14 h-14 bg-[#F5F7FA] rounded-full flex items-center justify-center text-[#C8102E] shrink-0" data-id="element-467">
                    <Clock className="w-6 h-6" data-id="element-468" />
                  </div>
                  <div data-id="element-469">
                    <h3 className="text-xl font-bold text-[#0A1F44] mb-2" data-id="element-470">
                      Service Times
                    </h3>
                    <p className="text-gray-600" data-id="element-471">
                      Sunday Worship: 10:00 AM
                      <br data-id="element-472" />
                      Impact Wednesday: 7:00 PM
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Contact Form */}
            <div className="bg-[#F5F7FA] p-8 md:p-12 rounded-2xl border border-[#C8102E]/10 shadow-sm" data-id="element-473">
              <h3 className="text-2xl font-serif font-bold text-[#0A1F44] mb-6" data-id="element-474">
                Send a Message
              </h3>
              <form className="space-y-6" data-id="element-475">
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-6" data-id="element-476">
                  <div data-id="element-477">
                    <label htmlFor="firstName" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-478">
                      First Name
                    </label>
                    <input type="text" id="firstName" className="w-full px-4 py-3 rounded-lg border border-gray-200 focus:outline-none focus:ring-2 focus:ring-[#0A1F44] focus:border-transparent transition-all" placeholder="John" data-id="element-479" />
                  </div>
                  <div data-id="element-480">
                    <label htmlFor="lastName" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-481">
                      Last Name
                    </label>
                    <input type="text" id="lastName" className="w-full px-4 py-3 rounded-lg border border-gray-200 focus:outline-none focus:ring-2 focus:ring-[#0A1F44] focus:border-transparent transition-all" placeholder="Doe" data-id="element-482" />
                  </div>
                </div>

                <div data-id="element-483">
                  <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-484">
                    Email Address
                  </label>
                  <input type="email" id="email" className="w-full px-4 py-3 rounded-lg border border-gray-200 focus:outline-none focus:ring-2 focus:ring-[#0A1F44] focus:border-transparent transition-all" placeholder="john@example.com" data-id="element-485" />
                </div>

                <div data-id="element-486">
                  <label htmlFor="subject" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-487">
                    Subject
                  </label>
                  <select id="subject" className="w-full px-4 py-3 rounded-lg border border-gray-200 focus:outline-none focus:ring-2 focus:ring-[#0A1F44] focus:border-transparent transition-all bg-white" data-id="element-488">
                    <option data-id="element-489">General Inquiry</option>
                    <option data-id="element-490">Prayer Request</option>
                    <option data-id="element-491">Join a Ministry</option>
                    <option data-id="element-492">Feedback</option>
                  </select>
                </div>

                <div data-id="element-493">
                  <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-494">
                    Message
                  </label>
                  <textarea id="message" rows={5} className="w-full px-4 py-3 rounded-lg border border-gray-200 focus:outline-none focus:ring-2 focus:ring-[#0A1F44] focus:border-transparent transition-all resize-none" placeholder="How can we help you?" data-id="element-495"></textarea>
                </div>

                <Button className="w-full bg-[#0A1F44] hover:bg-[#081833] text-white" size="lg" rightIcon={<Send className="w-4 h-4" data-id="element-497" />} data-id="element-496">
                  Send Message
                </Button>
              </form>
            </div>
          </div>
        </div>
      </section>

      {/* Map Section */}
      <section className="h-[500px] bg-gray-200 relative" data-id="element-498">
        {/* Placeholder for actual map implementation */}
        <div className="absolute inset-0 flex items-center justify-center bg-gray-200" data-id="element-499">
          <div className="text-center" data-id="element-500">
            <MapPin className="w-12 h-12 text-[#C8102E] mx-auto mb-4" data-id="element-501" />
            <p className="text-gray-600 font-medium" data-id="element-502">Map Integration Here</p>
          </div>
        </div>
      </section>
    </Layout>;
}